import MainApplication from "../MainApplication";
import RenderLoop from "./components/RenderLoop";

class Api
{
  
  init()
  {
    this.application = new MainApplication();
    this.render_loop = new RenderLoop(this.application);

    window.app = this.application;

    this.render_loop.start()
  }

}

const api = new Api();
export { api as Api };
